import { DatePicker } from "antd";
import { locale, t } from "../MainApp";
import { IObject } from "../App";
import dayjs, { Dayjs } from "dayjs";

type ReservationDatePickerProps = {
    object: IObject;
    selectedDate: Dayjs | null;
    onSelectedDateChange: (value: Dayjs | null) => void;
    disabled: boolean;
    locale: locale;
};

export function ReservationDatePicker(props: ReservationDatePickerProps) {

    function constraintDatePicker(date: Dayjs): boolean {
        let isThatDayWorking = false;

        for (const dayWorkTime of props.object.worktime) {
            if(dayWorkTime.dayOfWeek === date.day()) {
                isThatDayWorking = true;
            }
        }

        if (!isThatDayWorking || date < dayjs().startOf('day')) {
            return true;
        } else if (date.startOf("day") > dayjs().add(21, "days")) {
            return true;
        }

        return false;
    }

    return (
        <DatePicker
            style={{ width: '100%' }}
            onChange={(value) => props.onSelectedDateChange(value)}
            disabledDate={constraintDatePicker}
            value={props.selectedDate}
            placeholder={t(props.locale, "choosedate")}
            inputReadOnly={true}
            disabled={props.disabled}
        />
    );
}